import appLogger from "@next-platform/client-common-core/logger/appLogger";

import { LOCAL_STORAGE_KEYS } from "@/constants";

const logger = appLogger.withTag("ageVerificationModalStorage");

type StorageProvider = () => Storage;

// Prefer session-based persistence but fall back to localStorage when the session API is unavailable.
const preferredStorageProviders: StorageProvider[] = [() => window.sessionStorage, () => window.localStorage];

// Returns whichever storage implementation is available for persisting the modal flag.
const getStorage = (): Storage | null => {
  if (typeof window === "undefined") {
    return null;
  }

  for (const provider of preferredStorageProviders) {
    try {
      return provider();
    } catch {
      // Continue to the next provider if access is blocked (e.g. disabled cookies)
      continue;
    }
  }

  return null;
};

export const getAgeVerificationModalShownFlag = (): string | null => {
  const storage = getStorage();
  if (!storage) {
    return null;
  }

  try {
    return storage.getItem(LOCAL_STORAGE_KEYS.AGE_VERIFICATION_MODAL_SHOWN);
  } catch (error) {
    logger.error("Failed to read the age verification modal flag:", error);
    return null;
  }
};

export const setAgeVerificationModalShownFlag = (value: string): void => {
  const storage = getStorage();
  if (!storage) {
    return;
  }

  try {
    storage.setItem(LOCAL_STORAGE_KEYS.AGE_VERIFICATION_MODAL_SHOWN, value);
  } catch (error) {
    logger.error("Failed to write the age verification modal flag:", error);
  }
};
